import { create } from "zustand";

import { SearchQueryRequestedPage } from "types/generated";
import { UsePaginationFetchMoreProps } from "components/Table/Pagination/types";

type IntentProjectOperationsStore = {
  cursor: string | null;
  requestedPage: SearchQueryRequestedPage;
  onFetchItems: (props: UsePaginationFetchMoreProps) => void;
  resetPagination: () => void;
};

const useIntentProjectOperationsStore = create<IntentProjectOperationsStore>((set) => ({
  cursor: null,
  requestedPage: SearchQueryRequestedPage.First,
  onFetchItems: ({ cursor, requestedPage }) => set({ cursor, requestedPage }),
  resetPagination: () => set({ cursor: null, requestedPage: SearchQueryRequestedPage.First }),
}));

export default useIntentProjectOperationsStore;
